const servicesData = [
    {
        id:"1",
        icons:require("../../assets/icons/Portrait.svg").default,
        title:"Portrait Photography",
        details:"ersonalized photoshoots to bring out your true essence"
    },
    {
        id:"2",
        icons:require("../../assets/icons/Commercial.svg").default,
        title:"Commercial Photography",
        details:"High-quality visuals for brands, products, and businesses."
    },
    {
        id:"3",
        icons:require("../../assets/icons/event.svg").default,
        title:"Event Photography",
        details:"Covering birthdays, engagements, corporate events, & more"
    },
    {
        id:"4",
        icons:require("../../assets/icons/Videography.svg").default,
        title:"Event Videography",
        details:"High-quality event coverage with professional editing"
    },
    {
        id:"5",
        icons:require("../../assets/icons/Films.svg").default,
        title:"Short Films &Documentaries",
        details:"Creative storytelling through compelling visuals"
    },
    {
        id:"6",
        icons:require("../../assets/icons/brands.svg").default,
        title:"Brand & Commercial Videos",
        details:"Eye-catching video content for businesses & social media"
    },
]

export default servicesData;